import { createRoutine } from 'redux-saga-routines';
//////////////////////////////////////////////////

const LOG_IN = 'LOG_IN';

const loginRoutine = createRoutine(LOG_IN);

export {
  loginRoutine,
};
